import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=7e86fc3c&scoped=true"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=7e86fc3c&prod&scoped=true&lang=css"
import style1 from "./Cliente.vue?vue&type=style&index=1&id=7e86fc3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e86fc3c",
  null
  
)

export default component.exports